import React, { Component } from 'react'
import ReactEcharts from 'echarts-for-react'
import helper from '../../../utils/helper'
import { getVolumeChartGroupByMessage } from '../../../utils/volumeMessages'

class GeneratedChart extends Component {

    gerarResumos = (resumos = [], comparar_periodos) => {
        const content_resumo = {
            min_med_max: (resumo) => {
                const p1 = resumo?.valores?.primeiro_periodo;
                const p2 = resumo?.valores?.segundo_periodo;

                let min = Number(p1?.min ?? 0).toFixed(2);
                let med = Number(p1?.med ?? 0).toFixed(2);
                let max = Number(p1?.max ?? 0).toFixed(2);

                if (comparar_periodos) {
                    min = (
                        <>
                            <span style={{ color: "#3D91FF" }}>{p1?.min ?? 0}</span> vs
                            <span style={{ color: "#3ECF8E" }}> {p2?.min ?? 0}</span>
                        </>
                    )
                    med = (
                        <>
                            <span style={{ color: "#3D91FF" }}>{p1?.med ?? 0}</span> vs
                            <span style={{ color: "#3ECF8E" }}> {p2?.med ?? 0}</span>
                        </>
                    )
                    max = (
                        <>
                            <span style={{ color: "#3D91FF" }}>{p1?.max ?? 0}</span> vs
                            <span style={{ color: "#3ECF8E" }}> {p2?.max ?? 0}</span>
                        </>
                    )
                }

                return (
                    <div>
                        <small><b>Max:</b> {max}</small>
                        <small><b>Med:</b> {med}</small>
                        <small><b>Min:</b> {min}</small>
                    </div>
                )
            },

            volume_total: (resumo) => {
                let value = resumo?.valores?.primeiro_periodo ?? 0;

                if (comparar_periodos) {
                    value = (
                        <>
                            <span style={{ color: "#3D91FF" }}>{resumo?.valores?.primeiro_periodo ?? 0}</span> vs
                            <span style={{ color: "#3ECF8E" }}> {resumo?.valores?.segundo_periodo ?? 0}</span>
                        </>
                    )
                }

                return <strong style={{ fontSize: "18px" }}>{value}</strong>
            },

            custo: (resumo) => {
                let value = resumo?.valores?.primeiro_periodo ?? 0;

                if (comparar_periodos) {
                    value = (
                        <>
                            <span style={{ color: "#3D91FF" }}>{resumo?.valores?.primeiro_periodo ?? 0}</span> vs
                            <span style={{ color: "#3ECF8E" }}> {resumo?.valores?.segundo_periodo ?? 0}</span>
                        </>
                    )
                }

                return <><strong style={{ fontSize: "18px" }}>{value}</strong> R$</>
            }
        }

        return (
            <div className="hdv-resumo-list">
                {resumos.map((resumo, index) => {
                    const renderResumo = content_resumo[resumo?.resumo_pre_definido];

                    return (
                        <div className="hdv-resumo" key={index}>
                            <i className={resumo?.icone ?? ''} />
                            <div id="content">
                                {resumo?.descricao}
                                {renderResumo ? renderResumo(resumo) : null}
                                {comparar_periodos && (
                                    <div>
                                        <span
                                            style={{
                                                color: resumo?.texto_explicativo?.color,
                                                fontWeight: "bold",
                                                paddingBottom: "5px"
                                            }}
                                        >
                                            {resumo?.texto_explicativo?.texto}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    )
                })}
            </div>
        );
    }

    gerarReferencias = (referencias = []) => {
        return (
            <details className="hdv-chart-refs" open>
                <summary>Referências</summary>

                <section style={{ padding: '8px 0' }}>
                    {referencias.map((ref, index) => {

                        if (ref.tipo_da_referencia === 'automacao') {
                            const condicoes = ref.automacao_detalhes?.condicoes_simplificadas ?? []

                            return (
                                <div
                                    key={index}
                                    className="hdv-ref-item d-flex flex-col"
                                    style={{ justifyContent: "flex-start" }}
                                >
                                    <strong>{ref.descricao}</strong>

                                    <span className="d-flex align-items-center">
                                        Cor:
                                        <div
                                            className="ref-line-color"
                                            style={{ backgroundColor: ref.cor_linha }}
                                        />
                                    </span>

                                    <span>Tipo: Automação</span>

                                    {condicoes.map((c, i) => (
                                        <span key={i}>
                                            Condição: {c.label} {c.value}
                                        </span>
                                    ))}
                                </div>
                            )
                        }

                        if (ref.tipo_da_referencia === 'dinamico') {
                            return (
                                <div
                                    key={index}
                                    className="hdv-ref-item d-flex flex-col"
                                    style={{ justifyContent: "flex-start" }}
                                >
                                    <strong>{ref.descricao}</strong>

                                    <span className="d-flex align-items-center">
                                        Cor:
                                        <div
                                            className="ref-line-color"
                                            style={{ backgroundColor: ref.cor_linha }}
                                        />
                                    </span>

                                    <span>Tipo: Valor Dinâmico</span>
                                    <span>Parâmetro: {ref?.campo_customizado?.descricao}</span>
                                    <span>Calcular como volume: {ref.calcula_como_volume ? "Sim" : "Não"}</span>
                                </div>
                            )
                        }

                        return (
                            <div
                                key={index}
                                className="hdv-ref-item d-flex flex-col"
                                style={{ justifyContent: "flex-start" }}
                            >
                                <strong>{ref.descricao}</strong>

                                <span className="d-flex align-items-center">
                                    Cor:
                                    <div
                                        className="ref-line-color"
                                        style={{ backgroundColor: ref.cor_linha }}
                                    />
                                </span>

                                <span>Tipo: Valor Fixo</span>
                                <span>Valor {ref.valor}</span>
                            </div>
                        )
                    })}
                </section>
            </details>
        );
    }

    formatTooltip = (params, series) => {
        if (!Array.isArray(params)) return "";

        let formatted = "";

        params.forEach((param, i) => {
            let value = Array.isArray(param.data) ? param.data[1] : param.data;
            value = Number(value ?? 0).toFixed(2);

            const serie = series?.[param.seriesIndex];
            if (serie?.calcular_como === "horimetro") {
                value = helper.decimalToTime(Number(value));
            }

            formatted += `
                <div style="display:flex;align-items:center">
                    <div style="
                        background-color:${param.color};
                        height:14px;
                        width:14px;
                        border-radius:7px;
                        margin-right:5px">
                    </div>
                    ${param.seriesName}: <b>${value}</b>
                </div>
            `
        })

        return formatted;
    }

    render() {
        const {
            id, descricao, series, xAxis, legend, resumos,
            referencias, comparacao, comparar_periodos, groupBy
        } = this.props;

        return (
            <div className="generated-chart" style={{ padding: '3px' }} id={`chart-id-${id}`}>
                <div className="generated-chart__header">
                    {series?.length > 0 && series[0]?.calcular_como !== 'padrao' && <label
                        style={{
                            fontSize: "18px",
                            fontWeight: 600,
                        }}>
                        <i
                            className="las la-info-circle"
                            style={{ cursor: "pointer" }}
                            title={getVolumeChartGroupByMessage(groupBy)?.title}
                            onClick={() => helper.dispatchEvent("showAviso", {
                                message: getVolumeChartGroupByMessage(groupBy)?.message
                            })}
                        >
                        </i>
                    </label>}
                    <h5>{descricao}</h5>
                </div>

                {resumos?.length > 0 && this.gerarResumos(resumos, comparar_periodos)}
                {referencias?.length > 0 && this.gerarReferencias(referencias)}

                <div className="hdv-chart">
                    {series?.length > 0 ? (
                        <>
                            <ReactEcharts
                                style={{ height: '400px', width: '100%' }}
                                option={{
                                    series,
                                    xAxis: { data: xAxis ?? [] },
                                    yAxis: {
                                        type: 'value',
                                        max: (v) => {
                                            const max = Number(v?.max ?? 0);
                                            return Math.ceil(max + Math.abs(max) * 0.1);
                                        },
                                        min: (v) => {
                                            const min = Number(v?.min ?? 0);
                                            return Math.floor(min - Math.abs(min) * 0.6);
                                        },
                                    },
                                    legend: { data: legend ?? [], type: 'scroll' },
                                    grid: { left: 65, right: 50, bottom: 80 },
                                    tooltip: {
                                        trigger: "axis",
                                        axisPointer: { type: "cross" },
                                        formatter: (p) => this.formatTooltip(p, series)
                                    },
                                    dataZoom: [
                                        { type: 'inside' },
                                        { bottom: 0, handleSize: '100%' }
                                    ]
                                }}
                            />

                            {comparacao && (
                                <div className="w-100 d-flex justify-content-center">
                                    <span
                                        style={{
                                            color: comparacao?.geral?.color,
                                            fontWeight: "bold",
                                            padding: "10px"
                                        }}
                                    >
                                        {comparacao?.geral?.texto}
                                    </span>
                                </div>
                            )}
                        </>
                    ) : (
                        <p style={{
                            margin: '12px 0',
                            textAlign: 'center',
                            color: '#a33131',
                            fontWeight: 'bold'
                        }}>
                            Erro ao carregar gráfico
                        </p>
                    )}
                </div>

                <hr />
            </div>
        )
    }
}

export default GeneratedChart
